import _ from 'underscore';
import React, { useCallback, useContext, useMemo } from 'react';
import { useConfirmDialog } from '@bingads-webui-campaign-react/common-hooks';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { MultiCouponClaimedDialogContent } from './multi-coupon-claimed-dialog-content';

export function useMultiCouponClaimedDialog(props) {
  const {
    activity,
    coupon,
    onCouponClaimDone = _.noop,
    getCouponCurrencyCode = _.noop,
  } = props;
  const i18n = useContext(I18nContext);

  const handleDoneDialog = useCallback(() => {
    activity.trace('[Coupon Prompt]: Dismiss Claimed MultiCoupon Dialog');
    onCouponClaimDone();
  }, [onCouponClaimDone, activity]);

  const content = useMemo(() => (
    <MultiCouponClaimedDialogContent
      coupon={coupon}
      getCouponCurrencyCode={getCouponCurrencyCode}
    />
  ), [coupon, getCouponCurrencyCode]);

  const dialogTitleText = i18n.getString(_TL_('You\'re all set!'));
  const confirmButtonText = i18n.getString(_TL_('Done'));

  return useConfirmDialog({
    title: dialogTitleText,
    content,
    confirmText: confirmButtonText,
    onConfirm: handleDoneDialog,
    className: 'multi-coupon-claimed-dialog-root',
    hideCancelButton: true,
  }, {
    activity,
    dialogName: 'MultiCouponClaimedDialog',
  });
}
